<template>
    <div>
        <common_header></common_header>

        <router-view v-slot="{ Component }" v-if="flag">
            <!-- <keep-alive>
                <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive"/>
            </keep-alive>
            <component :is="Component" :key="$route.name" v-if="!$route.meta.keepAlive"/> -->
            <keep-alive>
            <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive"/>
        </keep-alive>
        </router-view>
        <common_footer></common_footer>
    </div>
</template>

<script>
    import {provide, ref, nextTick} from 'vue'
    import common_header from '@/components/main_header'
    import common_footer from '@/components/main_footer'
    export default {
        name: "main",
        components: {
            common_header, common_footer
        },
        setup(){
            const flag = ref(true)
            const reload = () => {
                flag.value = false
                nextTick(() => {
                    flag.value = true
                })
            }
            provide("reload", reload)  //提供给子组件(main_tabs.vue)刷新使用
            return {
                flag
            }
        },
        mounted(){
            
        },
    }
</script>

<style scoped>

</style>
